import APIManager from 'modules/common/apiManager';
import { AdminDashboardWrapper, Alert, Button, DataWithLoader } from 'modules/theme';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import { Col, Row } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { connect } from 'react-redux';
import styled, { injectGlobal } from 'styled-components';
import { getTeam } from '../../../../common/utils/api';
import { HeaderData } from '../../../../screens/reporting/styles';
import { colors } from '../styles';
import {
  ChartWrapper,
  CountData,
  DataWrapperClass,
  FlexRow,
  InsightRow,
  InsightTitle,
  InsightWrapper,
  StateData,
  TextData,
  TitleAgent
} from '../styles/main';
import { getRandomColor } from '../utils/colorParser';
import AgentDashboardTileTheme from './AgentDashboardTileTheme';
import Filter from './Filter';
import LiveMonitorTileTheme from './LiveMonitorTileTheme';
import CommonManager from '../../../../../helpers/common';

injectGlobal`

  .header-title{
    line-height: 49px;
    font-size: 36px;
    font-weight: 700;
    margin-top: 30px;
    font-height: 49px;
    color: #2B3C93;
    letter-spacing: 0.1em;
    position: relative;
    bottom: 15px;
    left: 0;
  }
  .main-content-wrapper{
    background-color:transparent;
    box-shadow:none;
  }
  .btn-filter{
    margin-right: 75px;
  }
`;

const FixMargin = styled.div`
  .total-call-item-agent-tile {
    margin-right: 0px !important;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;

	// FIXED AS REQUESTED BY CHINMAY SIR, IGNORING THE INSTRUCTIONS OF ROHIT SIR
  // height: 100%;
  flex: 1;
  //   justify-content: center;
  text-align: center;
  font-size: 14px;
  //   padding: 70px;
  color: ${colors.colorCoreGray};

  @media (max-width: 768px) {
    padding: 0px;
  }

  img {
    max-height: 260px;
    width: 100%;
    margin: 0 auto;

    @media (max-width: 768px) {
      max-height: 200px;
    }
  }

  ${(props) => {
    if (props.size === 'small') {
      return `
        min-height: 80px;
        font-size: 12px;
        padding: 10px 20px;
      `;
    } else {
      return `
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
      `;
    }
  }};

  i {
    font-size: ${(props) => (props.size === 'small' ? '28px' : '14vh')};
    line-height: ${(props) => (props.size === 'small' ? '40px' : '18vh')};
    color: ${colors.colorCoreLightGray};
  }

  a {
    margin-top: 10px;
    align-self: center;
  }
`;


const Responsive = styled.div`

  @media only screen and (max-width: 1200px){
    .chart-wrapper-agent{
      width: 100%;
      margin-bottom:20px;

      &:last-child{
        margin-bottom: 0px;
      }
    }
  }

  `

const commonManager = new CommonManager();

export class AgentDashboardTheme extends Component {
  constructor(props) {
    console.log("constructor agent called")
    super(props);
    this.mAPI = new APIManager();
    this.open = this.open.bind(this)
    this.moduleName = 'Dashboard';
    this.state = {
      totalPerPage: 0,
      perPageCount: 10,
      currentPage: 1,
      loading: true,
      isActive: false,
      noDatadesposesValue: false,
      nouserSummeryGraph: false,
      noteamsCount: false,
      editData:false,
      agentTile: [
        {
          title: 'Outbound Calls',
          count: '00:00:00',
          icon: '/images/OutboundImg.png',
          graph: '/images/OutboundGraphCall.png',
          color: '#0E71EB'
        },
        {
          title: 'Inbound Calls',
          count: '00:00:00',
          icon: '/images/InboundImg.png',
          graph: '/images/OutboundGraphCall.png',
          color: '#4cb944',
        },
        {
          title: 'Average Talk Time',
          count: '00:00:00',
          icon: '/images/OutboundImg.png',
          graph: '/images/OutboundGraphCall.png',
          color: '#B1B1B1',
        },
      ],
      agentTileData: [
        {
          title: 'Total Call',
          count: 0,
          icon: '/images/icons/ic_total_call.svg',
        },
        {
          title: 'Inbound Call',
          count: 0,
          icon: '/images/icons/ic_inbound_call.svg',
        },
        {
          title: 'Outbound Call',
          count: 0,
          icon: '/images/icons/ic_outgoing_call.svg',
        },
      ],
      Filters: {},
      dashboardGraph: [],
      dataPie: [],
      userSummery: [],
      dataSummery: [],
      dataFilter: [],
    };
    this.handleFireAPI = this.handleFireAPI.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.getData = this.getData.bind(this);
  }

  async getFilter() {
    let teamList = await getTeam('', 100, 1);
    this.setState({ team: teamList });
  }

  getData(data) {
    let selectedTeam = [];
    if (data.selectedTeam && data.selectedTeam.length > 0) {
      data.selectedTeam.map((element) => {
        if (element.value) {
          selectedTeam.push(element.value);
        }
      });
    }

    let filter = {
      sendStartTime: data.startDate || '',
      sendEndTime: data.endDate || '',
      timezone: data.timezone || {},
      source: data.fromSelector || '',
      to: data.toSelector || '',
      freeTextSearch: data.freeTextSearch || '',
      teamIds: selectedTeam,
    };
    this.setState({
      Filters: filter,
      currentPage: 1,
      isActive: false,
      dataFilter: data,
      editData:true
    });
    this.handleFireAPI(filter);
  }

  componentDidMount(){
    let zone = commonManager.getTimeZone();
    const filterDurationOptions = [
      {value: "today", label: "Today"},
      {value: "yesterday", label: "Yesterday"},
      {value: "last24", label: "Last 24 Hrs"},
      {value: "lastweek", label: "Last 7 Days"},
      {value: "all", label: null},
    ];
    let filterDuration = localStorage.getItem("filterDuration");
    console.log({filterDuration});
    const filterDurationObject = filterDurationOptions.find((item) => (
      item.value === filterDuration
      ));
    console.log('filterDurationObject: ', filterDurationObject);
    const initialDatesBy = filterDurationObject && filterDurationObject.label || "Last 24 Hrs";

    const { startDate, endDate } = commonManager.calculateTimeRange(initialDatesBy, zone);
    this.setState({
      Filters:{
        sendEndTime:endDate,
        sendStartTime:startDate,
        timezone:zone,
        DatesBy:initialDatesBy
      },
      dataFilter:{
        DatesBy:initialDatesBy,
        sendEndTime:endDate,
        sendStartTime:startDate,
        timezone:zone,
      }
    }, () => this.handleFireAPI(this.state.Filters))
  }

  addGraphColor(data, colors) {
    return data.map((element, index) => {
      element.backgroundColor =
        colors && colors[index] ? colors[index] : '#22aa99';
      return element;
    });
  }

  handleFireAPI(filter = '') {
    console.log(`Dashboard URL ->`);
    console.log("logs-- handle Fire APi called")
    var that = this;
    this.setState({ loading: true });

    filter = filter || {};

    let tData = {
      ...filter,
    };
    this.mAPI.sendPostAPI(
      `voice-cdr-report/agent-graph`,
      tData,
      (data) => {
        if (data) {
          that.setState({ listData: data });

          if (data && data.userSummery) {
            let tC = [
              { key: 'Online', val: '00:00:00' },
              { key: 'Break', val: '00:00:00' },
              { key: 'Preview', val: '00:00:00' },
              { key: 'Ringing', val: '00:00:00' },
              { key: 'After Call Work', val: '00:00:00' },
              { key: 'Talk Time', val: '00:00:00' },
            ];
            for (let to of data.userSummery) {
              if (to && to.state === 'online') {
                tC[0].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              } else if (to && to.state === 'break') {
                tC[1].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              } else if (to && to.state === 'preview') {
                tC[2].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              } else if (to && to.state === 'ringing') {
                tC[3].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              } else if (to && to.state === 'ACW') {
                tC[4].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              } else if (to && to.state === 'talkTime') {
                tC[5].val = moment.utc(to.spentTime * 1000).format('HH:mm:ss');
              }
            }
            that.setState({ userSummery: data.userSummery, dataSummery: tC });

            let tData = [];
            let seriesTag = [{ data: tData }];
            for (let tD of data.userSummery) {
              tData.push({ x: tD.state, y: tD.spentTime });
            }
            let tOptionsData = {
              legend: {
                show: false,
              },
              chart: {
                type: 'polarArea',
              },
              title: {
                text: 'Time Spend',
              },
            };
            that.setState({
              seriesSummary: seriesTag,
              tOptionsSummaryData: tOptionsData,
            });
          } else {
            this.setState({
              dataSummery: [
                { key: 'Online', val: '00:00:00' },
                { key: 'Break', val: '00:00:00' },
                { key: 'Preview', val: '00:00:00' },
                { key: 'Ringing', val: '00:00:00' },
                { key: 'After Call Work', val: '00:00:00' },
                { key: 'Talk Time', val: '00:00:00' },
              ]
            });
          }

          let gLabels = [],
            gData = [];
          if (data && data.desposesChartData) {
            gLabels = data.desposesChartData.tags || [];
            gData = data.desposesChartData.values || [];
          }

          if (data && data.teamsCount) {
            gLabels = data.teamsCount.key || [];
            gData = data.teamsCount.doc_count || [];
          }

          that.setState({
            agentTile: [
              {
                title: 'Outbound Calls',
                count:
                  moment
                    .utc((data.TotalOutBoundTime || 0) * 1000)
                    .format('HH:mm:ss') || 0,
                icon: '/images/OutboundImg.png',
                graph: '/images/OutboundGraphCall.png',
                color: '#0E71EB'
              },
              {
                title: 'Inbound Calls',
                count:
                  moment
                    .utc((data.TotalInboundTime || 0) * 1000)
                    .format('HH:mm:ss') || 0,
                icon: '/images/InboundImg.png',
                graph: '/images/OutboundGraphCall.png',
                color: '#4cb944',
              },
              {
                title: 'Average Talk Time',
                count:
                  moment
                    .utc((data.averageTime || 0) * 1000)
                    .format('HH:mm:ss') || 0,
                icon: '/images/OutboundImg.png',
                graph: '/images/OutboundGraphCall.png',
                color: '#B1B1B1',
              },
            ],
          });
          that.setState({
            agentTileData: [
              {
                title: 'Total Call',
                count: data.TotalCall || 0,
                icon: '/images/icons/ic_total_call.svg',
              },
              {
                title: 'Inbound Call',
                count: data.TotalInboundCall || 0,
                icon: '/images/icons/ic_inbound_call.svg',
              },
              {
                title: 'Outbound Call',
                count: data.TotalOutBoundCall || 0,
                icon: '/images/icons/ic_outgoing_call.svg',
              },
            ],
          });

          if (data && data.desposesValue && data.desposesValue.length) {
            that.setState({ noDatadesposesValue: false });
            let i = 0;
            let tData = [];
            let seriesTag = [{ data: tData }];
            for (let tD of data.desposesValue) {
              tData.push({ x: tD.key, y: tD.doc_count });
            }
            let tOptionsData = {
              legend: {
                show: false,
              },
              chart: {
                type: 'polarArea',
              },
              title: {
                text: 'Dispositions',
              },
              responsive: [
                {
                  breakpoint: 1000,
                  options: {
                    chart: {
                      polarArea: {
                        horizontal: false,
                      },
                    },
                    legend: {
                      show: false,
                    },
                  },
                },
              ],
            };
            that.setState({
              seriesTag: seriesTag,
              tOptionsData: tOptionsData,
            });
          } else {
            that.setState({ noDatadesposesValue: true });
          }

          if (data && data.teamsCount && data.teamsCount.length) {
            that.setState({ noteamsCount: false });
            let i = 0;
            let tDataa = [];
            let seriesTeam = [{ data: tDataa }];
            for (let tD of data.teamsCount) {
              tDataa.push({ x: tD.key, y: tD.doc_count });
            }
            let tOptions = {
              legend: {
                show: false,
              },
              chart: {
                height: '550px',
                type: 'polarArea',
              },
              title: {
                text: 'Teams',
              },
            };
            that.setState({
              series: seriesTeam,
              tOptions: tOptions,
            });
          } else {
            that.setState({ noteamsCount: true });
          }

          let gLabelss = [],
            gDatas = [];

          if (data && data.userSummeryGraph && data.userSummeryGraph.value) {
            const sum = data.userSummeryGraph.value.reduce(
              (partialSum, a) => partialSum + a,
              0
            );

            if (sum !== 0) {
              that.setState({ nouserSummeryGraph: false });

              gLabelss = data.userSummeryGraph.labels || [];
              gDatas = data.userSummeryGraph.value || [];

              that.setState({
                dataPie: {
                  labels: gLabelss,
                  datasets: [
                    {
                      label: 'tags',
                      data: gDatas,
                      backgroundColor: gDatas.map((o) => getRandomColor()),
                      hoverOffset: 4,
                    },
                  ],
                },
              });
            } else {
              that.setState({ nouserSummeryGraph: true });
            }
          } else {
            that.setState({ nouserSummeryGraph: true });
          }
          that.setState({ loading: false });
        }
      },
      (error, data) => {
        that.setState({ loading: false });
        console.log(`Error:`, error);
        Alert.error('Error');
      }
    );
  }

  generateGraph(cData) {
    let tData = {
      labels: cData.labels,
      plot: {
        animation: {
          sequence: 3,
          effect: 4,
          method: 1,
          speed: 500,
        },
      },
      datasets: [],
    };
    if (cData.data) {
      cData.data.forEach((element) => {
        let datasets = {
          label: element.label || 'none',
          // lineTension: element.lineTension || 0.1,
          backgroundColor: element.backgroundColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)',
          ],
          borderColor: element.borderColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)',
          ],
          borderCapStyle: element.borderCapStyle || 'butt',
          borderDash: element.borderDash || [],
          borderDashOffset: element.borderDashOffset || 0.0,
          borderJoinStyle: element.borderJoinStyle || 'miter',
          pointBorderColor: element.pointBorderColor || '#4D528E',
          pointBackgroundColor: element.pointBackgroundColor || '#fff',
          pointBorderWidth: element.pointBorderWidth || 1,
          pointHoverRadius: element.pointHoverRadius || 5,
          pointHoverBackgroundColor:
            element.pointHoverBackgroundColor || '#4D528E',
          pointHoverBorderColor: element.pointHoverBorderColor || '#4D528E',
          pointHoverBorderWidth: element.pointHoverBorderWidth || 2,
          pointRadius: element.pointRadius || 1,
          pointHitRadius: element.pointHitRadius || 10,
          data: element.data || [],
          fill: false,
        };
        tData.datasets.push(datasets);
      });
    }
    return tData;
  }

  renderTitle(title, props) {
    const { __ } = this.context;
    return (
      <InsightTitle
        className='boxsmall-title'
        {...props}
      >
        {__(title)}
      </InsightTitle>
    );
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  getSelectedColumnNames() {
    return [];
  }
  renderContent() {
    const { brands, history, queryParams } = this.props;
    const filterDurationOptions = [
      {value: "today", label: "Today"},
      {value: "yesterday", label: "Yesterday"},
      {value: "last24", label: "Last 24 Hrs"},
      {value: "lastweek", label: "Last 7 Days"},
      {value: "all", label: null},
    ];
    let filterDuration = localStorage.getItem("filterDuration");
    console.log({filterDuration});
    const filterDurationObject = filterDurationOptions.find((item) => (
      item.value === filterDuration
      ));
    console.log('filterDurationObject: ', filterDurationObject);
    const initialDatesBy = filterDurationObject && filterDurationObject.label || "Today";

    console.log(initialDatesBy, "DatesByyyyy initial");
    return (
      <InsightWrapper className='filter-insight-wrapper'>
        <HeaderData>
          <h6>Filter</h6>
          <div
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
              }
            }}
            style={{ cursor: 'pointer', zIndex: '999' }}
            className='filter-header-bar'
          >
            <span class='material-symbols-outlined'> cancel</span>
          </div>
        </HeaderData>
        <Filter
          filterList={['renderTeam']}
          initialDatesBy={initialDatesBy}
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={this.state.dataFilter}
          selectedFilter={this.state.selectedFilter}
          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
          TeamList={this.state.team}
          DefaultSelectedField={{DatesBy:initialDatesBy}}
          editData={this.state.editData}
          clearable={false}
        />
      </InsightWrapper>
    );
  }

  componentWillReceiveProps(nextProps) {
    console.log("logs-- component Will recive props")
    console.log("logs-- nextProps", nextProps)
    console.log("logs-- curent Props", this.props)
    if (nextProps.agentDashboardId !== this.props.agentDashboardId) {
      this.handleFireAPI();
    }
  }

  render() {
    const { agentDashboardId } = this.props;

    const { __ } = this.context;
    const breadcrumb = [{ title: __('Dialpad'), link: '/dial-pad' }];

    const options = {
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
            // barPercentage: 0.5
          },
        ],
        yAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
            // barPercentage: 0.5
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          },
        ],
      },
    };

    const doughnutOptions = {
      responsive: true,
      maintainAspectRatio: true,
      tooltips: {
        callbacks: {
          // title: function(tooltipItem, data) {
          //   // return data['labels'][tooltipItem[0]['index']];
          //   return "aaaa";
          // },
          label: function (tooltipItem, data) {
            console.log('tooltipItem', tooltipItem, data);
            let lable = data['labels'][tooltipItem['index']];
            console.log('lable', lable);
            return lable;
          },
          afterLabel: function (tooltipItem, data) {
            var dataset = data['datasets'][0];
            // var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
            let lable = '';
            if (
              dataset &&
              dataset['data'] &&
              typeof tooltipItem['index'] != 'undefined' &&
              dataset['data'][tooltipItem['index']]
            ) {
              lable = moment
                .utc(dataset['data'][tooltipItem['index']] * 1000)
                .format('HH:mm:ss');
            }
            return lable;
          },
        },
        backgroundColor: '#FFF',
        titleFontSize: 16,
        titleFontColor: '#0066ff',
        bodyFontColor: '#000',
        bodyFontSize: 14,
        displayColors: false,
      },
    };

    const mainContent = (
      <Row style={{ padding: '20px' }}>
        <InsightRow
          className='totalcalls'
          style={{
            paddingBottom: '20px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <FixMargin>
            <AgentDashboardTileTheme
              loading={this.state.loading}
              data={this.state.agentTile}
              options={options}
            />
          </FixMargin>
        </InsightRow>
        <Col className='chart-wrapper-agent' sm={4}>
          <ChartWrapper>
            {this.renderTitle('Total Progress')}
            {this.state.nouserSummeryGraph ? (
              <EmptyStateStyled>
                <img src='images/icons/ic_tag_empty.svg' />
                <span>Graph data not available</span>
              </EmptyStateStyled>
            ) : (
              <Doughnut
                ref='chart'
                height={250}
                data={this.state.dataPie}
                options={doughnutOptions}
              />
            )}
          </ChartWrapper>
        </Col>
        <Col className='chart-wrapper-agent' sm={4}>
          <ChartWrapper style={{ marginRight: '20px' }}>
            {this.renderTitle('Dispositions')}
            {this.state.noDatadesposesValue ? (
              <EmptyStateStyled>
                <img src='images/icons/ic_tag_empty.svg' />
                <span>Graph data not available</span>
              </EmptyStateStyled>
            ) : (
              this.state.tOptionsData && (
                <Chart
                  options={this.state.tOptionsData}
                  series={this.state.seriesTag}
                  type='treemap'
                  height={250}
                />
              )
            )}
          </ChartWrapper>
        </Col>
        <Col className='chart-wrapper-agent' sm={4}>
          <InsightRow>
            <FlexRow>
              <ChartWrapper style={{ height: 'auto' }}>
                {this.renderTitle('Teams')}
                {this.state.noteamsCount ? (
                  <EmptyStateStyled>
                    <img src='images/icons/ic_tag_empty.svg' />
                    <span>Graph data not available</span>
                  </EmptyStateStyled>
                ) : (
                  this.state.tOptions && (
                    <Chart
                      options={this.state.tOptions}
                      series={this.state.series}
                      type='treemap'
                      height={250}
                    />
                  )
                )}
              </ChartWrapper>
            </FlexRow>
          </InsightRow>
        </Col>
      </Row>
    );

    return (
      <Responsive className='heightClass' key={agentDashboardId}>
        <DataWrapperClass>
          {this.state.isActive && this.renderContent()}
          <span
            className={this.state.isActive ? 'addClass' : 'removeClass'}
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
              }
            }}
          >
            <AdminDashboardWrapper
              header={<AdminDashboardWrapper.Header breadcrumb={breadcrumb} />}
              heading={
                <TitleAgent>
                  Hello,{' '}
                  <span
                    style={{
                      color: '#000',
                    }}
                  >
                    {this.props.currentUser && this.props.currentUser.name
                      ? this.props.currentUser.name
                      : ''}
                  </span>
                </TitleAgent>
              }
              content={
                <div>
                  <DataWithLoader
                    data={mainContent}
                    loading={this.state.loading}
                  />
                </div>
              }
              filterOnClick={this.open}
              right={true}
              sidebar={
                <InsightRow className='leftdashboard livepadding-right-box'>
                  <span className='sidebar-title'>
                    {this.renderTitle('CALL & AGENT STATS', { headingColor: '#2B3C93 !important' })}
                  </span>
                  <LiveMonitorTileTheme
                    loading={this.state.loading}
                    data={this.state.agentTileData}
                    options={options}
                    forAgentDashboard={true}
                  />
                  <hr />
                  <div className='px-8' style={{overflowY: 'auto', height: 'calc(100vh - 400px)'}}>
                    {this.state.dataSummery.map((o) => (
                      <div className='px-2 mb-2'>
                        <StateData>
                          <TextData>{o.key}</TextData>
                          <CountData>{o.val}</CountData>
                        </StateData>
                      </div>
                    ))}
                  </div>
                </InsightRow>
              }
            />
          </span>
        </DataWrapperClass>
      </Responsive>
    );
  }
}

AgentDashboardTheme.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({});

const dispatchToProps = (dispatch) => ({});
export default connect(stateToProps, dispatchToProps)(AgentDashboardTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AgentDashboardTheme.js